import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import logo from "../../../assets/images/prokraya-logo-new1.png";
import usericon from "../../../assets/images/user.jpg";
import Icon from "../../../components/icon";
import {
  calculateRemainingDays,
  convertDateFormat,
} from "../../../functions/common";
import { env, env_url } from "./../../../environments/env";
import HttpServices from "./../../../environments/environment_urls";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languageOpts: [
        { value: "English", label: "English" },
        { value: "Arabic", label: "Arabic" },
      ],
      setNewHeaderLine: false,
      dropdownOpen: false,
      insideDropdownOpen: false,
      notifyOpen: false,
      userInfData: "",
      userOrgData: "",
      notificationList: [],
      taskOpen: false,
      taskList: [],
      pageNo: 1,
      totalRecords: 0,
      pagePerSize: 10,
      notificationCount: 0,
      planInfo: [],
      supplierStatus: localStorage.getItem("supplierStatus"),
    };
  }

  // changeLanguage = (selectedOption) => {
  //   console.log(`Selected Language:`, selectedOption);
  // };

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };
  loadSwitch = (m) => {
    this.props.history.push({
      pathname: "/",
      state: { id: m.userName },
    });
    setTimeout(() => {
      this.props.history.push({
        pathname: "/switch-user-tasks",
        state: { id: m.userName },
      });
    }, 1200);
  };
  onMouseEnter = () => {
    this.setState({ insideDropdownOpen: true });
  };

  onMouseLeave = () => {
    this.setState({ insideDropdownOpen: false });
  };
  toggleInsideDropdown = () => {
    this.setState({ insideDropdownOpen: !this.state.insideDropdownOpen });
  };
  toggleNotifyDropdown = () => {
    this.setState({ notifyOpen: !this.state.notifyOpen });
  };

  toggleTaskDropdown = () => {
    this.setState({ taskOpen: !this.state.taskOpen });
  };

  componentDidMount() {
    this.updateWindowDimensions();
    this.notificationData();
    this.getALLPendingTasks(1, 5);
    this.userData();
    this.updateWindowDimensions();
    window.addEventListener("load", this.updateWindowDimensions);
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ setNewHeaderLine: false });
  };

  userData = () => {
    const url = env_url.getLoggedInUser;
    HttpServices.getData(url).then((response) => {
      if (response.data) {
        this.setState({
          userInfData: response.data,
          userOrgData: response.data.umOrgDtl[0],
        });
        this.getUserOrgProperties();
      }
    });
  };

  getUserInfo = (state, props, toggleDropdown, toggleInsideDropdown) => {
    return (
      <Dropdown
        className={"user-dropdown " + (!state.setNewHeaderLine ? "ml-4" : "")}
        isOpen={state.dropdownOpen}
        toggle={toggleDropdown}
      >
        <DropdownToggle tag="span">
          <img
            className={"user-icon " + (state.dropdownOpen ? "active" : "")}
            src={
              state.userInfData?.photoPath
                ? `data:image/png;base64,${state.userInfData.photoPath}`
                : usericon
            }
            alt="user"
          />
        </DropdownToggle>
        <DropdownMenu className="user-dropdown-menu" right>
          {state.userInfData?.name ? (
            <React.Fragment>
              <h4 className="user-name">{state.userInfData?.name}</h4>
              <p className="user-role">{state.userInfData?.designation}</p>
            </React.Fragment>
          ) : (
            ""
          )}
          <DropdownItem divider />
          {!this.state.supplierStatus && (
            <DropdownItem
              className={"menu-option " + (props.profile ? "active" : "")}
            >
              <Link to="/account">
                <Icon iconName="user" className="mr-2" iconSize={22} />
                Profile
              </Link>
            </DropdownItem>
          )}
          {env.userInfo &&
            env.userInfo?.authorities.some(
              (item) =>
                item.authority !== "SUPPLIER_ADMIN" &&
                item.authority !== "SUPPLIER_USER" &&
                item.authority !== "SUPERADMIN" &&
                item.authority !== "SYSADMIN"
            ) && (
              <DropdownItem className={"menu-option"}>
                <Dropdown
                  isOpen={state.insideDropdownOpen}
                  toggle={this.toggleInsideDropdown}
                  direction="right"
                  onMouseOver={this.onMouseEnter}
                  onMouseLeave={this.onMouseLeave}
                >
                  <DropdownToggle tag="span" caret>
                    <Icon
                      iconName="suppliers-event"
                      className="mr-2"
                      iconSize={18}
                    />
                    Switch User Tasks
                  </DropdownToggle>
                  <DropdownMenu>
                    {env.userInfo && env.userInfo.delegatedUsers?.length > 0 ? (
                      env.userInfo.delegatedUsers.map((m) => {
                        return (
                          <DropdownItem className={"menu-option"}>
                            <Link
                              onClick={() => {
                                this.props.location?.pathname ===
                                "/switch-user-tasks"
                                  ? this.loadSwitch(m)
                                  : this.props.history.push({
                                      pathname: "/switch-user-tasks",
                                      state: { id: m.userName },
                                    });
                              }}
                            >
                              <Icon
                                iconName="user"
                                className="mr-2"
                                iconSize={22}
                              />
                              {m.name}
                            </Link>
                          </DropdownItem>
                        );
                      })
                    ) : (
                      <DropdownItem className={"menu-option"}>
                        No User Tasks
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </Dropdown>
              </DropdownItem>
            )}
          <DropdownItem className="menu-option" onClick={this.logOutUser}>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                this.logOutUser();
              }}
            >
              <Icon iconName="power" className="mr-2" iconSize={22} /> Logout
            </a>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  getUserOrgProperties = () => {
    env.baseCountry = this.state.userOrgData.orgCountry;
    env.baseCurrency = this.state.userOrgData.currency;
    env.dateFormat = this.state.userOrgData.dateFormat;
    env.taxName = this.state.userOrgData.defaultTax;
    env.paymentTerm = this.state.userOrgData.defaultPaymentTerms;
    env.orgId = this.state.userOrgData.id;
    env.suppId = this.state.userInfData.id;
  };

  notificationData = (pageNumber, pageSize) => {
    let notificationList = [];
    const url = env_url.getALLEmails;
    const formData = new FormData();
    formData.append("pagenum", pageNumber ? pageNumber - 1 : 0);
    formData.append("pagesize", pageSize ? pageSize : env.pageSize);
    HttpServices.postData(url, formData).then((response) => {
      if (response.data) {
        response.data.map((item) => {
          const e = {
            id: item.id,
            title: item.notifSubject,
            name: item.fromUser,
            trackId: item.id,
            dateTime: item.recievedDate,
          };
          return notificationList.push(e);
        });

        let tRecs = 0;
        if (notificationList.length > 0)
          tRecs = notificationList[0].totalRecords;

        this.setState({
          notificationList: notificationList,
          pageNo: pageNumber,
          pagePerSize: pageSize,
          totalRecords: tRecs,
        });
      }
    });
    const countUrl = env_url.getALLUnReadEmailsCount;
    HttpServices.getData(countUrl).then((response) => {
      if (response.data) {
        this.setState({ notificationCount: response.data });
      }
    });
  };

  getALLPendingTasks = (pageNumber, pageSize) => {
    let taskList = [];
    const formData = new FormData();
    formData.append("pageNo", pageNumber ? pageNumber - 1 : 0);
    formData.append("pageSize", pageSize ? pageSize : env.pageSize);
    const url = `${env_url.getALLPendingTasks}`;
    HttpServices.postData(url, formData).then((response) => {
      if (response.data) {
        response.data.map((item) => {
          const e = {
            id: item.contextSite,
            title: item.subject,
            status: item.currentStatus,
            trackId: item.initiator,
            dateTime: item.inboxDate,
            taskName: item.taskName,
            startDate: item.startDate,
            totalRecords: item.totalRecords,
          };
          return taskList.push(e);
        });
        this.setState({ taskList: taskList });
      }
    });
  };

  logOutUser = (e) => {
    e.stopPropagation();
    localStorage.clear();
    window.location.href = "/signin";
    setTimeout(() => {
      localStorage.clear();
    }, 1000);
  };

  handleClick = () => {
    console.log("reached here");
    this.setState({ taskOpen: false, notifyOpen: false });
  };

  taskList = (state, toggleTaskDropdown) => {
    return (
      <Dropdown
        className="task-dropdown"
        isOpen={state.taskOpen}
        toggle={toggleTaskDropdown}
      >
        <DropdownToggle tag="div" className="task-block p-2 mr-3">
          <Icon iconName="notification" iconSize={22} />
          <span className="task-block-count">
            {state.taskList && state.taskList.length > 0
              ? state.taskList[0].totalRecords
              : 0}
          </span>
        </DropdownToggle>
        {state.taskList.length !== 0 ? (
          <DropdownMenu className="task-dropdown-menu" right>
            {state.taskList.slice(0, 4).map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <DropdownItem tag="div" className="task-item">
                    <Link className="d-flex" to="/my-tasks">
                      <div className={"shortname shortname-bg-" + index}>
                        {item.taskName
                          ? item.taskName.match(/\b(\w)/g).join("")
                          : ""}
                      </div>
                      <div className="content-description">
                        <h5 className="title mb-0">
                          {item.title ? item.title.substr(0, 30) : ""}
                        </h5>
                        <div className="label">
                          {" "}
                          {item.trackId ? item.trackId.substr(0, 35) : "NA"}
                        </div>
                        <div className="label">
                          {convertDateFormat(
                            item.startDate,
                            "DD-MM-YYYY HH:mm"
                          )}
                        </div>
                      </div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem divider />
                </React.Fragment>
              );
            })}

            <Link className="view-all" to="/my-tasks">
              <div className="text-center" onClick={this.handleClick}>
                View All
              </div>
            </Link>
          </DropdownMenu>
        ) : (
          ""
        )}
      </Dropdown>
    );
  };

  notificationList = (state, toggleNotifyDropdown) => {
    return (
      <Dropdown
        className="notification-dropdown"
        isOpen={state.notifyOpen}
        toggle={toggleNotifyDropdown}
      >
        <DropdownToggle tag="div" className="notification-block p-2">
          <Icon iconName="mail-new" iconSize={22} />
          <span className="notification-block-count">
            {state.notificationCount ? state.notificationCount : 0}
          </span>
        </DropdownToggle>
        {state.notificationList.length !== 0 ? (
          <DropdownMenu className="notification-dropdown-menu" right>
            {state.notificationList.slice(0, 4).map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <DropdownItem tag="div" className="notification-item">
                    <Link className="d-flex" to="/notification-detail">
                      <div className={"shortname shortname-bg-" + index}>
                        {item.name.match(/\b(\w)/g).join("")}
                      </div>
                      <div className="content-description">
                        <h5 className="title mb-0">
                          {item.title.substr(0, 30)}
                        </h5>
                        <div className="label mb-1">{item.name}</div>
                        <div className="label">
                          {convertDateFormat(item.dateTime, "DD-MM-YYYY HH:mm")}
                        </div>
                      </div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem divider />
                </React.Fragment>
              );
            })}
            {!this.state.supplierStatus && (
              <Link className="view-all" to="/notification-detail">
                <div className="text-center" onClick={this.handleClick}>
                  View All
                </div>
              </Link>
            )}
          </DropdownMenu>
        ) : (
          ""
        )}
      </Dropdown>
    );
  };

  render() {
    const state = this.state;
    const props = this.props;
    return (
      <Fragment>
        <header>
          <div className="header-block">
            <div className="header-content">
              <h3 className="header-content-title d-flex align-items-center mb-0">
                <div
                  className="btn-menu-toggle"
                  onClick={() => props.handleToggleSidebar(true)}
                >
                  <Icon iconName="Paragraph mr-4" iconSize={24} />
                </div>
                {props.linkToBack && (
                  <Link to={props.linkToBack ? props.linkToBack : "/"}>
                    <Icon iconName="back-arrow mr-2" iconSize={24} />
                  </Link>
                )}
                <span style={{ fontSize: "10px" }}>Powered By </span>
                <img
                  src={logo}
                  alt="Company Logo"
                  className="header-logo"
                  width={54}
                  height={54}
                />
              </h3>

              {state.planInfo &&
              state.planInfo.planName === "Trial" &&
              calculateRemainingDays(state.planStartDate, state.planEndDate) >
                0 ? (
                <div className="main-screen">
                  <h3 className="header-content-title d-flex align-items-center mb-0">
                    <div className="label ml-2">
                      Your Trial Period will expire in{" "}
                      {calculateRemainingDays(
                        state.planStartDate,
                        state.planEndDate
                      )}{" "}
                      days.
                    </div>
                    <Link
                      className="btn btn-primary btn-sm ml-20"
                      to="/my-subscription"
                    >
                      Buy
                    </Link>
                    <a
                      href="https://prokraya.com/book-demo"
                      target="_blank"
                      className="btn btn-primary btn-sm ml-10"
                      rel="noreferrer"
                    >
                      Request Demo
                    </a>
                  </h3>
                </div>
              ) : (
                ""
              )}

              <div className="d-flex align-items-center">
                <span className="d-flex align-items-center">
                  {!state.setNewHeaderLine && state.userInfData?.name ? (
                    <span className="main-screen">
                      Welcome,&nbsp;<b>{state.userInfData?.name}</b>&nbsp;&nbsp;
                    </span>
                  ) : (
                    ""
                  )}

                  {this.taskList(state, this.toggleTaskDropdown)}

                  {this.notificationList(state, this.toggleNotifyDropdown)}
                </span>

                {/* {!props.supplier && (
                <div className="lang-select d-flex align-items-center mr-3 px-2">
                  <Icon iconName="language-selection" iconSize={22} />
                  <Input type="select"
                    options={state.languageOpts}
                    getChanges={this.changeLanguage}
                    isSearchable={false}
                    placeholderText="Choose Language"
                    defaultValue={state.languageOpts[0]}
                  />
                </div>
              )} */}
                {!state.setNewHeaderLine &&
                  state.userInfData &&
                  this.getUserInfo(
                    state,
                    props,
                    this.toggleDropdown,
                    this.toggleInsideDropdown
                  )}
              </div>

              {/* {(props.quickLinksList && props.quickLinksList.length > 0) && (
              <div className="nav-another-menu">
                <ul className="nav-ul-menu">
                  {props.quickLinksList.map((item, index) => {
                    return (
                      <li key={index}><Link className={item.selected ? "activate" : "menu-option"} to={item.to ? item.to : '/'}>{item.name}</Link></li>
                    )
                  })}
                </ul>
              </div>
            )} */}
            </div>
          </div>
        </header>
        {state.planInfo &&
        state.planInfo.planName === "Trial" &&
        calculateRemainingDays(state.planStartDate, state.planEndDate) > 0 ? (
          <div className="mobile-screen">
            <h3 className="header-content-title d-flex align-items-center mb-0">
              <div className="label ml-2">
                Your Trial Period will expire in{" "}
                {calculateRemainingDays(state.planStartDate, state.planEndDate)}{" "}
                days.
              </div>
              <Link
                className="btn btn-primary btn-sm ml-20"
                to="/my-subscription"
              >
                Buy
              </Link>
              <a
                href="https://prokraya.com/book-demo"
                target="_blank"
                className="btn btn-primary btn-sm ml-10"
                rel="noreferrer"
              >
                Request Demo
              </a>
            </h3>
          </div>
        ) : (
          ""
        )}

        {state.setNewHeaderLine &&
        state.planInfo?.planName &&
        state.userInfData?.name ? (
          <div className="user-block-head d-flex align-items-center justify-content-end">
            <span>
              Welcome,&nbsp;<b>{state.userInfData?.name}</b>&nbsp;&nbsp;
            </span>
            {this.getUserInfo(
              state,
              props,
              this.toggleDropdown,
              this.toggleInsideDropdown
            )}
          </div>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}

export default React.memo(withRouter(Header));
